module.exports = __webpack_public_path__ + "img/platform-icon-zomato.941f4f77.svg";